export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  passwordConfirmInput: "auth-password-confirm-input",
  nameInput: "auth-name-input",
  submitButton: "auth-submit-button",
  error: "auth-error",
  success: "auth-success",
  termsCheckbox: "auth-terms-checkbox",
  privacyCheckbox: "auth-privacy-checkbox",
  newsletterCheckbox: "auth-newsletter-checkbox",
  forgotPasswordLink: "auth-forgot-password-link",
  registerLink: "auth-register-link",
  loginLink: "auth-login-link",
  googleButton: "auth-google-button",
  resendVerificationButton: "auth-resend-verification-button",
  verifyBanner: "auth-verify-banner",
};

export const APP = {
  shell: "app-shell",
  sidebar: "app-sidebar",
  sidebarToggle: "app-sidebar-toggle",
  navLibrary: "app-nav-library",
  navLibraryActive: "app-nav-library-active",
  navFavorites: "app-nav-favorites",
  navSaved: "app-nav-saved",
  navRecent: "app-nav-recent",
  navUpdates: "app-nav-updates",
  navBonuses: "app-nav-bonuses",
  navAccount: "app-nav-account",
  navHelp: "app-nav-help",
  navFull: "app-nav-full",
  logoutButton: "app-logout-button",
  loader: "app-loader",
};

export const LIBRARY = {
  root: "library-root",
  empty: "library-empty",
  emptyCta: "library-empty-cta",
  packageCard: "library-package-card",
  packageGrid: "library-package-grid",
  categoryFilter: "library-category-filter",
  promptCard: "library-prompt-card",
  promptOpen: "library-prompt-open",
  favoriteToggle: "library-favorite-toggle",
  backLink: "library-back-link",
  searchInput: "library-search-input",
  featuredSection: "library-featured-section",
  allSection: "library-all-section",
  showMoreButton: "library-show-more-button",
  searchResults: "library-search-results",
  fullCtaTop: "library-full-cta-top",
  fullCtaBottom: "library-full-cta-bottom",
};

export const FAVORITES = {
  root: "favorites-root",
  empty: "favorites-empty",
  card: "favorites-card",
  removeButton: "favorites-remove-button",
  openButton: "favorites-open-button",
};

export const CREATOR = {
  root: "prompt-creator-root",
  backLink: "prompt-back-link",
  title: "prompt-title",
  favoriteButton: "prompt-favorite-button",
  form: "prompt-form",
  generateButton: "prompt-generate-button",
  quoteBox: "prompt-quote-box",
  resultReady: "prompt-result-ready",
  usageCard: "prompt-usage-card",
  compiledOutput: "prompt-compiled-output",
  copyButton: "prompt-copy-button",
  copyOpenButton: "prompt-copy-open-button",
  saveButton: "prompt-save-button",
  regenerateButton: "prompt-regenerate-button",
  imageInput: "prompt-image-input",
  toolInstruction: "prompt-tool-instruction",
  rescueButton: "prompt-rescue-button",
  rescueOutput: "prompt-rescue-output",
  rescueCopyButton: "prompt-rescue-copy-button",
  upsellCard: "prompt-upsell-card",
  historyList: "prompt-history-list",
};

export const ACCOUNT = {
  root: "account-root",
  email: "account-email",
  nameInput: "account-name-input",
  saveButton: "account-save-button",
  entitlements: "account-entitlements",
  noAccess: "account-no-access",
  logoutAllButton: "account-logout-all-button",
  verifyStatus: "account-verify-status",
  pwCurrent: "account-pw-current",
  pwNew: "account-pw-new",
  pwConfirm: "account-pw-confirm",
  pwSubmit: "account-pw-submit",
};


export const MATCHER = {
  root: "matcher-root",
  question: "matcher-question",
  option: "matcher-option",
  backButton: "matcher-back-button",
  restartButton: "matcher-restart-button",
  results: "matcher-results",
  resultCard: "matcher-result-card",
  openPromptButton: "matcher-open-prompt-button",
  seePackageButton: "matcher-see-package-button",
  noMatch: "matcher-no-match",
  seeOthersButton: "matcher-see-others-button",
};

export const HELP = {
  root: "help-root",
  search: "help-search-input",
  searchEmpty: "help-search-empty",
  searchEmptyCta: "help-search-empty-cta",
  quickAction: "help-quick-action",
  categoryChip: "help-category-chip",
  article: "help-article",
  articleToggle: "help-article-toggle",
  legalLink: "help-legal-link",
  contactCta: "help-contact-cta",
  matcherCta: "help-matcher-cta",
};

export const CONTACT = {
  root: "contact-root",
  nameInput: "contact-name-input",
  emailInput: "contact-email-input",
  messageInput: "contact-message-input",
  consentCheckbox: "contact-consent-checkbox",
  submitButton: "contact-submit-button",
  success: "contact-success",
  error: "contact-error",
};

export const PAYMENTS = {
  walletChip: "wallet-balance-chip",
  topupButton: "wallet-topup-button",
  buyModal: "buy-credits-modal",
  buyClose: "buy-credits-close",
  buyError: "buy-credits-error",
  pack: "credit-pack",
  payButton: "buy-credits-pay-button",
  statusRoot: "payment-status-root",
  processing: "payment-processing",
  success: "payment-success",
  failure: "payment-failure",
  newBalance: "payment-new-balance",
};

export const AI = {
  modal: "ai-action-modal",
  runButton: "ai-run-button",
  insufficient: "ai-insufficient",
  topupButton: "ai-topup-button",
  fieldHint: "ai-field-hint",
  improveButton: "ai-improve-button",
  genShort: "ai-generate-short",
  genLong: "ai-generate-long",
  resultBox: "ai-result-box",
};
